import { render, staticRenderFns } from "./pages6.vue?vue&type=template&id=c2297d18&scoped=true&"
import script from "./pages6.vue?vue&type=script&lang=js&"
export * from "./pages6.vue?vue&type=script&lang=js&"
import style0 from "./pages6.vue?vue&type=style&index=0&id=c2297d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2297d18",
  null
  
)

export default component.exports